<i18n>
{
  "de": {
    "locationHeader": "Standort",
    "noLocation": "Standortdaten fehlen",
    "noAddressDefined": "Standort nicht gefunden",
    "egid": "EGID"
  }
}
</i18n>

<template>
  <DetailListItem :title="$t('locationHeader')" expandable @expand="onModalOpen">
    <div class="value">
      <MissingDataLabel v-if="building.latitude === null || building.longitude === null">
        {{ $t('noLocation') }}
      </MissingDataLabel>
      <div v-for="(location, index) in locationData" :key="index" class="location-row">
        <span class="egid">
          {{ location.egid ? $t('egid') + ' ' + location.egid : '-' }}
        </span>
        <span class="address">
          {{ location.address || '-' }}
        </span>
      </div>
    </div>

    <template #modal>
      <LocationModal v-if="isModalOpen" :building="building" @close="onModalClose" />
    </template>
  </DetailListItem>
</template>

<script>
import ModalMixin from '@/components/shared/ModalMixin.vue'

import DetailListItem from '@/components/shared/lists/DetailListItem.vue'
import MissingDataLabel from '@/components/shared/MissingDataLabel.vue'
import LocationModal from '@/components/building/overview/LocationModal.vue'

export default {
  mixins: [
    //
    ModalMixin,
  ],

  components: {
    DetailListItem,
    MissingDataLabel,
    LocationModal,
  },

  props: {
    building: {
      type: Object,
      required: true,
    },
  },

  computed: {
    locationData() {
      // Array of objects with EGID and address
      // [
      //   {
      //     egid: '1234567890',
      //     address: 'Namederstrasse 1, 1234 Gemeinde',
      //   },
      // ]
      const result = []
      const building = this.building

      // Look for the building.egids in the building.gwr.entries
      // If found, add the address to the result
      // If not found, add the address only (leave the egid empty)
      if (building.egids?.length) {
        building.egids.forEach((item) => {
          const gwrEntry = building.gwr.entries.find((entry) => entry.properties.egid === item)
          if (gwrEntry) {
            result.push({ egid: item, address: gwrEntry.properties.strname_deinr })
          } else {
            result.push({ egid: item, address: '' })
          }
        })
      } else if (building.addresses?.length) {
        building.addresses.forEach((item) => {
          result.push({ egid: '', address: item })
        })
      }
      return result
    },
  },
}
</script>

<style lang="scss" scoped>
.value {
  display: flex;
  flex-direction: column;
}

.location-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;

  & .egid {
    flex: 1;
    min-width: 120px;
  }

  & .address {
    flex: 2;
  }
}
</style>
